import { ca } from '@cian/analytics';

type ICommandPageviewData = Parameters<typeof ca<'pageview'>>[1];

export function trackPageview(eventData: ICommandPageviewData) {
  ca('pageview', eventData);
}
